import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SessionFun from './functions/sessionFun';
import { getUserInfo } from './functions/userInfo';
import { Form, Modal } from 'react-bootstrap';
import close from '../Asset/close.svg';
import mapi from '../Asset/map.png';
import deli from '../Asset/delete-i.png';
import editi from '../Asset/edit-i.svg';
import * as atlas from 'azure-maps-control';
import Alert from './Alert';
import {environment} from './functions/environment';

var ployType = "";
var map, dataSource, layersList = [], polyPoint = [], polyCord = [];
var CirclePoint = new atlas.Shape(new atlas.data.Point([-73.985708, 40.75773]), null, {
    subType: "Circle",
    radius: 50
});
var circleLayer = new atlas.layer.PolygonLayer(dataSource, null, {
    fillColor: 'red',
    fillOpacity: 0.5
})
var opLocUrl = "";
function CreateGeo() {
    const mapContainerRef = useRef(null);
    let userObj = getUserInfo();
    let [type, setType] = useState();
    let [formData, setformData] = useState({
        siteID: "",
        geoType: "",
        geoName: "",
        geoID: "",
        opType: "",
    });
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [sessOut, setSessOut] = useState(false);
    let [sites, setSites] = useState([]);
    let [radius, setRadius] = useState(50);
    let [geofenceId, setGeofenceId] = useState();
    let [ccord, setCcord] = useState([]);
    let [pcord, setPcord] = useState([]);
    let [geoList, setGeoList] = useState([]);
    let [cp, setCp] = useState([]);
    let [save, setSave] = useState(false);
    let [viewMode, setViewMode] = useState("list");
    let [deletItem, setDeletItem] = useState({
        uid:"",
        gid:null
    });
    const [show, setShow] = useState(false);
    const handleShow = (uid,gid) => {
        setDeletItem({
            uid:uid,
            gid:gid
        })
        setShow(true);
    }
    const handleClose = () => setShow(false);
    useEffect(() => {
        getLocation();
        getSiteByAccountId();
        getGeoList();
    }, []);

    function getFormData(e) {
        setformData({ ...formData, [e.target.name]: e.target.value });
    }
    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                let log = position.coords.longitude;
                let lat = position.coords.latitude;
                let cord = [];
                cord.push(log, lat)
                setCp(cord);
                InitMap(cord);
            });
        } else {
            setAlert({
                msg: "Geolocation is not supported by this browser.",
                status: true
            })
        }
    }

    function InitMap(cord) {
        var compo = document.getElementById("mapDiv");
        map = new atlas.Map(compo, {
            center: cord,//[72.877426, 19.076090],
            zoom: 16,
            language: 'en-US',
            // renderWorldCopies: false,
            // view: "Auto",
            authOptions: {
                authType: 'subscriptionKey',
                subscriptionKey: 'du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU'
            },
            showLogo: false,
            showFeedbackLink: false
        });

        map.events.add('ready', function () {
            dataSource = new atlas.source.DataSource();
            map.sources.add(dataSource);
            //add onclick event
            map.events.add('click', function (e) {
                if (ployType == "Point") {
                    addCircle(e.position);
                }
                else if (ployType == "Polygon") {
                    addMarkers(e.position);
                }
                else {
                    map.layers.remove(layersList);
                    layersList = [];
                }
            });
        });
    }

    function addMarkers(cord) {
        var layer = new atlas.layer.SymbolLayer(dataSource);
        layersList.push(layer);
        map.layers.add(layer);
        //Create a point and add it to the data source.
        polyCord.push(cord);
        var point = new atlas.data.Point(cord);
        polyPoint.push(point);
        dataSource.add(point);
    }
    function markPolygon() {
        var layer = new atlas.layer.PolygonLayer(dataSource, 'myPolygonLayer', {
            fillColor: 'rgba(0, 200, 200, 0.5)'
        });
        layersList.push(layer);
        map.layers.add(layer);
        var polygon = new atlas.Shape(new atlas.data.Polygon(polyCord));
        polyPoint.push(polygon);
        dataSource.add(polygon);
        setPcord(polyCord);
    }

    function markCreatedPolygon(para) {
        var layer = new atlas.layer.PolygonLayer(dataSource, 'myPolygonLayer', {
            fillColor: 'rgba(0, 200, 200, 0.5)'
        });
        layersList.push(layer);
        map.layers.add(layer);
        var polygon = new atlas.Shape(new atlas.data.Polygon(para));
        polyPoint.push(polygon);
        dataSource.add(polygon);
    }

    function addCircle(cord) {
        map.layers.remove(layersList);
        layersList = [];
        CirclePoint.setCoordinates(cord);
        dataSource.add(CirclePoint);
        setCcord(cord);
        var layer = new atlas.layer.PolygonLayer(dataSource, null, {
            fillColor: 'red',
            fillOpacity: 0.2
        });
        layersList.push(layer);
        map.layers.add(layersList);
    }
    function getMarkType(e) {
        let val = e.target.value;
        setformData({ ...formData, geoType: val });
        setType(val);
        clearAllLayears();
        if (val == "Point") {
            ployType = "Point";
        }
        else if (val == "Polygon") {
            ployType = "Polygon"
        }
        else {
            ployType = "";
        }
    }
    function getRadius(e) {
        let rad = parseInt(e.target.value);
        CirclePoint.addProperty("radius", rad);
        setRadius(rad);
    }
    function plusMinusRadi(type) {
        let r = radius;
        if (type == "plus" && r < 20000) {
            r++;
            setRadius(r);
        }
        else {
            if (r > 50) {
                r--;
                setRadius(r);
            }
        }
        CirclePoint.addProperty("radius", r);
    }
    function clearAllLayears() {
        dataSource.clear();
        if (layersList.length > 0) {
            map.layers.remove(layersList);
        }
        layersList = [];
        polyPoint = [];
        polyCord = [];
        setCcord([]);
        setPcord([]);
    }
    function resetAllValue() {
        clearAllLayears();
        setRadius(50);
        setGeofenceId(null);
        setCcord([]);
        setPcord([]);
        setformData({
            siteID: "",
            geoType: "",
            geoName: "",
            geoID: "",
            opType: ""
        })
        setType("");
    }
    function getSiteByAccountId() {
        fetch(environment.baseUrl + "/getSiteByUserAccount", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "accountID": userObj.accountID })
        }).then((result) => {

            result.json().then((res) => {
                if (res.code == 200) {
                    setSites(res.data.result.siteList);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSites([])
                }
            })

        })
    }
    function getGeoList() {
        fetch(environment.baseUrl + "/listGeofence", {
            method: "get",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((result) => {

            result.json().then((res) => {
                if (res.code == 200) {
                    setGeoList(res.data.result.geofenceList);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setGeoList([])
                }
            })

        })
    }
    function getValue() {
        if (formData.siteID == "") {
            setAlert({
                msg: "Please select site",
                status: true
            });
        }
        else if (formData.geoName == "") {
            setAlert({
                msg: "Please enter geofence name",
                status: true
            });
        }
        else if (formData.geoType == "") {
            setAlert({
                msg: "Please select geofence type",
                status: true
            });
        }
        else if (formData.geoType == "Point" && ccord.length == 0) {
            setAlert({
                msg: "Please select cordinates on map",
                status: true
            });
        }
        else if (formData.geoType == "Polygon" && pcord.length < 3) {
            setAlert({
                msg: "Please select cordinates on map",
                status: true
            });
        }
        else {
            setSave(true);
            if (formData.opType == "edit") {
                let req = getGeoReq(formData.geoID);
                azurApiOne(req, formData.geoID);
            }
            else {
                generateGeofenceID();
            }
        }
    }
    function generateGeofenceID() {
        fetch(environment.baseUrl + "/generateGeofenceID", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "siteID": formData.siteID })
        }).then((result) => {

            result.json().then((res) => {
                if (res.code == 200) {
                    let id = res.data.result.geofenceData.geofenceID;
                    setformData({ ...formData, geoID: id });
                    setGeofenceId(id);
                    let req = getGeoReq(id);
                    azurApiOne(req, id);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })

        })
    }

    function getGeoReq(siteid) {
        let cordp = pcord;
        if (cordp.length > 0) {
            cordp.push(pcord[0]);
        }
        let polyCord = [];
        polyCord.push(cordp);
        let cordc = [];
        cordc.push(ccord);
        if (formData.geoType == "Polygon") {
            return {
                "features": [
                    {
                        "geometry": {
                            "coordinates": polyCord,
                            "type": "Polygon"
                        },
                        "properties": {
                            "geometryId": siteid,
                            "radius": 0
                        },
                        "type": "Feature"
                    }
                ],
                "type": "FeatureCollection"
            }
        }
        else {
            return {
                "geometry": {
                    "coordinates": ccord,
                    "type": "Point"
                },
                "properties": {
                    "geometryId": siteid,
                    "radius": radius,
                    "subType": "Circle"
                },
                "type": "Feature"
            }
        }
    }

    function azurApiOne(reqs, gid) {
        fetch("https://us.atlas.microsoft.com/mapData?subscription-key=du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU&api-version=2.0&dataFormat=geojson", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqs)
        }).then((result) => {
            let nextUrl = result.headers.get("Operation-Location");
            opLocUrl = nextUrl;
            azurOperationLoc(nextUrl, gid);
        })
    }
    function azurOperationLoc(url, idg) {
        fetch(url + "&subscription-key=du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU", {
            method: "Get",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((result) => {
            if (result.status == 200) {
                result.json().then((res) => {
                    if (res.status == "Succeeded") {
                        let nextUrl = result.headers.get("Resource-Location");
                        azurResourceLoc(nextUrl, idg);
                    }
                    else {
                        updateGeoFence(url, idg, "Pending", idg);
                    }
                });
            }
            else {
                updateGeoFence(url, idg, "Pending", idg)
            }
        })
    }
    function azurResourceLoc(url, geoId) {
        fetch(url + "&subscription-key=du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU", {
            method: "Get",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((result) => {
            if (result.status == 200) {
                result.json().then((res) => {
                    updateGeoFence(res.location, res.udid, res.uploadStatus, geoId);
                })
            }
        })
    }

    function updateGeoFence(url, id, status, pgid) {
        let gid = pgid ? pgid : formData.geoID;
        let cord = [];
        if (formData.geoType == "Polygon") {
            let temp = pcord;
            temp.push(pcord[0]);
            cord.push(temp);
        }
        else {
            let temp = [];
            temp.push(ccord);
            cord.push(temp);
        }

        fetch(environment.baseUrl + "/updateGeofence", {
            method: "Put",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({

                "coordinates": cord,
                "geofenceID": gid,
                "geofenceName": formData.geoName,
                "locationURL": url,
                "radius": formData.geoType == "Polygon" ? 50 : radius,
                "siteID": parseInt(formData.siteID),
                "type": formData.geoType,
                "udid": id.toString(),
                "uploadStatus": status
            })
        }).then((result) => {

            result.json().then((res) => {
                setSave(false);
                if (res.code == 200) {
                    resetAllValue();
                    getGeoList();
                    setViewMode("list");
                    setAlert({
                        msg: res.msg,
                        status: true
                    });
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else if(res.code == 400) {
                    setAlert({
                        msg: "Please update status again.",
                        status: true
                    });
                }
            })

        })
    }

    function AzureStatusUpdate(item) {
        setformData({
            siteID: item.siteID,
            geoType: item.type,
            geoName: item.geofenceName,
            geoID: item.geofenceID,
            opType: "status"
        });
        if (item.type == "Polygon") {
            let temp = item.coordinates
            temp.pop();
            setPcord(temp);
        }
        else {
            setCcord(item.coordinates[0]);
        }

        setRadius(item.radius);
        azurOperationLoc(item.locationURL, item.geofenceID);
    }
    function modelDelete()
    {
        handleClose();
        deleteAzurGeo(deletItem.uid, deletItem.gid);
    }
    function deleteAzurGeo(uid, gid) {
        fetch("https://us.atlas.microsoft.com/mapData/" + uid + "?subscription-key=du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU&api-version=2.0", {
            method: "Delete",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((result) => {
            if (result.status == 204) {
                deleteGeo(gid);
            }
            else {
                setAlert({
                    msg: "Error occured, please try again.",
                    status: true
                });
            }
        })
    }
    function deleteGeo(gid) {
        fetch(environment.baseUrl + "/removeGeofence/" + gid, {
            method: "Put",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((result) => {
            if (result.status == 200) {
                getGeoList();
                setAlert({
                    msg: "Geofence deleted successfully.",
                    status: true
                });
                setDeletItem({
                    uid:"",
                    gid:null
                })
                clearAllLayears();
                resetAllValue();
            }
        })
    }
    function showGeo(params, type) {
        clearAllLayears();

        if (type == "edit") {
            ployType = params.type;
            setType(params.type);
            setformData({
                siteID: params.siteID,
                geoType: params.type,
                geoName: params.geofenceName,
                geoID: params.geofenceID,
                opType: type
            });
            setRadius(params.radius);
            setViewMode("add");
            if (params.type == "Polygon") {
                let temp = params.coordinates
                temp.pop();
                setPcord(temp);
            }
            else {
                setCcord(params.coordinates[0])
            }
        }
        
        let cord = [];
        cord = getCenterPoint(params.coordinates);
        if (params.type == "Polygon") {
            let temp = params.coordinates;
            markCreatedPolygon(temp);
        }
        else {
            addCircle(params.coordinates[0]);
            CirclePoint.addProperty("radius", params.radius);
        }
        setCamera(cord);
    }
    function setCamera(cord) {
        map.setCamera({
            center: cord,
            zoom: 16,
            duration: 3000,
            type: 'fly'
        });
    }
    function addGeo() {
        setformData({ ...formData, opType: "add" });
        clearAllLayears();
        setViewMode("add");
        setCamera(cp);
    }
    function getCenterPoint(array) {
        let x = 0, y = 0, z = 0;
        array.forEach(element => {
            let log = element[0] * Math.PI / 180;
            let lat = element[1] * Math.PI / 180;
            x += Math.cos(lat) * Math.cos(log);
            y += Math.cos(lat) * Math.sin(log);
            z += Math.sin(lat);
        });

        let total = array.length;
        x = x / total;
        y = y / total;
        z = z / total;

        let clog = Math.atan2(y, x);
        let csqr = Math.sqrt(x * x + y * y);
        let clat = Math.atan2(z, csqr);

        let rlog = clog * 180 / Math.PI;
        let rlat = clat * 180 / Math.PI;

        return [rlog, rlat]
    }
    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Create Geofence</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Create Geofence
            </p>
            <div className="card-box-block mt-3" style={{ width: "100%" }}>
                <div className="w-100">
                    <div className="row mb-3">
                        <div className="col-sm-6 left-col align-self-center">
                            <button className={viewMode == "add" ? 'btn-primary add-btn' : 'd-none'} onClick={() => { setViewMode("list"); setCamera(cp) }} ><i className='fa fa-chevron-left ml-2'></i> Back</button>
                        </div>
                        <div className="col-sm-6 text-end right-col">
                            <button onClick={addGeo} className={viewMode == "list" ? 'btn-primary add-btn' : 'd-none'}>Add <i className='fa fa-plus-circle ml-2'></i></button>
                        </div>
                    </div>
                </div>


                <div className={viewMode == "add" ? "row mb-2" : "d-none"}>
                    <Form.Group className='p-0'>
                        <Form.Label>Site</Form.Label>
                        <Form.Select className='textbox-back' name="siteID" value={formData.siteID} onChange={getFormData}>
                            <option value="">Select Site</option>
                            {
                                sites.map((item, index) =>
                                    <option key={index} value={item.siteID}>{item.siteName}</option>
                                )
                            }
                        </Form.Select>
                    </Form.Group>
                </div>

                <div id="mapDiv" className="row mb-3" style={{ height: '400px' }}></div>

                <table className={viewMode == "list" ? "table mt-3" : "d-none"}>
                    <thead className='table-secondary'>
                        <tr>
                            <th scope="col">Geofence Name</th>
                            <th scope="col">Geofence Type</th>
                            <th scope="col">Site</th>
                            <th scope="col">Status</th>
                            <th scope="col">View</th>
                            <th scope="col" className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            geoList.map((item, index) =>
                                <tr key={index}>
                                    <td>{item.geofenceName}</td>
                                    <td>{item.type}</td>
                                    <td>{item.siteName}</td>
                                    <td>
                                        {item.uploadStatus == "Pending" ?
                                            <button className='btn btn-link px-0' onClick={() => AzureStatusUpdate(item)}>{item.uploadStatus}</button>
                                            : item.uploadStatus
                                        }
                                    </td>
                                    <td><img className='mr-2' src={mapi} style={{ cursor: 'pointer' }} width="25" height="25" onClick={() => { showGeo(item) }} /></td>
                                    <td className="text-center">
                                        {item.uploadStatus == "Completed" ?
                                            <>
                                                <img className='ml-2' src={editi} style={{ cursor: 'pointer' }} width="20" height="20" onClick={() => { showGeo(item, "edit") }} />&nbsp; &nbsp;
                                                <img className='ml-2' src={deli} style={{ cursor: 'pointer' }} width="25" height="25" onClick={()=>handleShow(item.udid, item.geofenceID)} />
                                            </>
                                            : "NA"
                                        }
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>

                <div className={viewMode == "add" ? "row mb-2" : "d-none"}>
                    <div className="col-sm-4 left-col align-self-center">
                        <Form.Group>
                            <Form.Select className='textbox-back' name="geoType" value={formData.geoType} onChange={getMarkType}>
                                <option value="">Select Geofence Type</option>
                                <option value="Polygon">Polygon</option>
                                <option value="Point">Point</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    <div className="col-sm-4">
                        {
                            type == "Point" ?
                                <>
                                    <p id="text" className="form-label m-0 text-center">{radius} M</p>
                                    <div className="row">
                                        <div className="col-sm-1 align-self-center">
                                            <i className="fa fa-minus" style={{ cursor: "pointer" }} onClick={() => plusMinusRadi("minus")}></i>
                                        </div>
                                        <div className="col-sm-9">

                                            <input type="range" className="form-range" min='50' max='20000' value={radius} onInput={getRadius}></input>
                                        </div>
                                        <div className="col-sm-1 align-self-center">
                                            <i className="fa fa-plus" style={{ cursor: "pointer" }} onClick={() => plusMinusRadi("plus")}></i>

                                        </div>
                                    </div>
                                </>
                                : type == "Polygon" ?

                                    <button className="add-bt btn-light lo-btn float-start" onClick={markPolygon}>
                                        Close Region
                                    </button>
                                    :
                                    <></>
                        }
                    </div>
                    <div className="col-sm-4 right-col align-self-center">
                        <button className="add-bt btn-light lo-btn float-start" onClick={clearAllLayears}>
                            Clear Region
                        </button>
                    </div>
                </div>

                <div className={viewMode == "add" ? "row mb-2" : "d-none"}>
                    <Form.Group className='p-0'>
                        <Form.Control className='textbox-back' placeholder='Enter Geofence Name' name="geoName" value={formData.geoName} onChange={getFormData}>
                        </Form.Control>
                    </Form.Group>
                </div>

                <div className={viewMode == "add" ? "row justify-content-end mt-3" : "d-none"}>
                    {
                        save ?
                            <button className="ad-btn btn-save" style={{ width: 200 }} type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                &nbsp; {formData.opType == "edit" ? "Updating Geofence" : "Creating Geofence"}
                            </button>

                            :
                            <button className="ad-btn btn-save" style={{ width: 200 }} onClick={getValue}>
                                {formData.opType == "edit" ? "Update Geofence" : "Create Geofence"}
                            </button>
                    }
                </div>
            </div>

            <Modal show={show} onHide={handleClose} centered backdrop="static" size="sm">
                <Modal.Header>
                    <Modal.Title>Delete Geofence</Modal.Title>
                    <button onClick={handleClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='logout-box'>
                    <p className='text-center'><b>Do you want to delete this geofence?</b></p>

                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn btn-light lo-btn confirm-btn float-start" onClick={modelDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CreateGeo
